module.exports = __webpack_public_path__ + "static/media/partner-5.cea326a8.jpeg";